/**
 * The row open in the section below a buyer-board table (the Line section
 * under the line table, the order under the Orders table). A solid band with a
 * thick bar, so the buyer finds their place at a glance: the faint grey Gains
 * uses for the current row is what buyers asked us not to copy.
 */
export const SELECTED_ROW_CLASS =
  'bg-yellow-200/70 shadow-[inset_4px_0_0_0_var(--color-amber-500)] dark:bg-yellow-900/40';
